


import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/effect-creative";




import { initScrollFoundation } from "../modules/core/base/scroll-foundation.js";
import { initDebug } from "../modules/core/base/debug.js";
import { initErrorTraceHandlers } from "../modules/core/base/errorTrace.js";


import { initAllLibraries } from "../modules/core/base/libraries.js";
import { setLanguage } from "../modules/core/base/language.js";
import { setMetaTags } from "../modules/core/base/meta.js";
import { initForms, handleSubmissionParams } from "../modules/core/ui/forms.js";

import { initObservers } from "../modules/core/observers/index.js";
import { initNavigation } from "../modules/core/ui/navigation.js";
import { initFixedHeaderGSAP } from "../modules/core/ui/sticky-header.js";
import { initTextdynamic } from "../modules/core/ui/textdynamic.js";

import { initGradientVideoLoader } from "../modules/core/media/gradientVideoLoader.js";
import { initReverseLoopVideos } from "../modules/core/media/reverseLoopVideo.js";
import { initAllSections } from "../modules/project/sections/all-sections.js";
import { initGeneralAnimations } from "../modules/core/animations/index.js";
import { startCountingStatements } from "../modules/core/animations/macros/counting-statements-ani.js";


import { initCustomCursor } from "../modules/project/components/customCursor.js";
import { initVisitenkarten } from "../modules/project/components/visitenkarten.js";
import { initHeroSwiper } from "../modules/project/components/heroSwiper.js";
import { initWirkungSlideshow } from "../modules/project/components/wirkungSlideshow.js";
import { initWirkungVideos } from "../modules/project/components/wirkungVideos.js";
import { initConsentBanner } from "../modules/project/components/consentBanner.js";
import { initWebsiteNavigator } from "../modules/project/components/website_navigator/index.js";
import { initServiceAddDropdowns } from "../modules/project/pages/services.js";


import "../../src/css/entry/main.css";



const page =
  document.querySelector('meta[name="page-context"]')?.content ||
  (location.pathname.includes("privacy") || location.pathname.includes("policy") ? "policy" : "home");

function setLanguageAndMeta(lang) {
  setLanguage(lang);
  setMetaTags(lang, page);
}
window.setLanguage = setLanguageAndMeta;

function parseScale(raw, fallback, min, max) {
  const value = Number(raw);
  if (!Number.isFinite(value)) return fallback;
  return Math.min(max, Math.max(min, value));
}

function applyAnimationRuntimeScales() {
  const body = document.body;
  if (!body) return;
  const durationScale = parseScale(body.dataset.aniDurationScale, 1, 0.25, 2);
  const delayScale = parseScale(body.dataset.aniDelayScale, 1, 0, 2);
  document.documentElement.style.setProperty("--ani-duration-scale", String(durationScale));
  document.documentElement.style.setProperty("--ani-delay-scale", String(delayScale));
}

function deferNonCriticalInit(task, { idleTimeout = 1200, fallbackDelay = 180 } = {}) {
  if (typeof task !== "function") return;
  const runTask = () => {
    window.requestAnimationFrame(() => {
      task();
    });
  };
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(runTask, { timeout: idleTimeout });
    return;
  }
  window.setTimeout(runTask, fallbackDelay);
}

const cursorRuntimeSettings = {
  customCursor: __WR_CUSTOM_CURSOR_ENABLED__,
  cursorTrail: __WR_CURSOR_TRAIL_ENABLED__,
};

document.addEventListener("DOMContentLoaded", async () => {


  initScrollFoundation();
  applyAnimationRuntimeScales();
  initDebug();
  initErrorTraceHandlers();
  
  const lang = localStorage.getItem("language") || "en";
  await initAllLibraries();

  setLanguageAndMeta(lang);
  handleSubmissionParams();

  
  initForms();
  initObservers();
  initNavigation();
  initConsentBanner();
  initTextdynamic();
  initVisitenkarten();
  initHeroSwiper();
  initGradientVideoLoader();
  initReverseLoopVideos();
  initWirkungSlideshow();
  initWirkungVideos();
  initWebsiteNavigator();
  initServiceAddDropdowns();
  deferNonCriticalInit(() => {
    initFixedHeaderGSAP();
    initGeneralAnimations();
    window.requestAnimationFrame(() => {
      startCountingStatements(document);
    });
  });
  const scrollVideoTarget = document.querySelector("[data-scroll-video]");
  const scrollVideoEnabled =
    document.body?.dataset.scrollVideoEnabled !== "false" &&
    document.body?.dataset.scrollVideoEnabled !== "0";
  if (scrollVideoEnabled && scrollVideoTarget) {
    const { initScrollVideoBg } = await import(
      "../modules/project/components/scrollVideoBg.js"
    );
    initScrollVideoBg();
  }

  
  initCustomCursor(cursorRuntimeSettings);

  
  initAllSections();
});
